import React from "react";
import { Input } from "components/bootstrap";
const WhoisAdapterFieldSet = ({ config, handleFormEvent, validationMessage, validationState }) => {
  /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "connect_timeout",
      name: "connect_timeout",
      label: "Connect timeout",
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("connect_timeout", "WHOIS connection timeout in milliseconds."),
      bsStyle: validationState("connect_timeout"),
      value: config.connect_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "read_timeout",
      name: "read_timeout",
      label: "Read timeout",
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("read_timeout", "WHOIS connection read timeout in milliseconds."),
      bsStyle: validationState("read_timeout"),
      value: config.read_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ));
};
export default WhoisAdapterFieldSet;
